import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';
import { fieldRequired, requiredInput } from '../../../core/formValidation';

export const VendorFormFields = ({ fields }) => {
  return (
    <div className="inline-add-item-button">
      {fields.map((vendor, index) => (
        <div key={index} className="field-row">
          <div className="field-row-heading">
            <p>{`Vendor #${index + 1}`}</p>
            <button
              className={classNames('close', 'no-float', 'multi-form-delete')}
              onClick={() => {
                fields.remove(index);
              }}
            >
              <i className="icon icon-squared-cross" />
            </button>
          </div>
          <div className="form-group">
            <Field
              className="form-control row-padding"
              name={`${vendor}.name`}
              id="name"
              component={requiredInput}
              type="text"
              aria-describedby="descriptionHelp"
              placeholder="Name"
              validate={[fieldRequired]}
            />
          </div>
        </div>
      ))}
      <button
        className={classNames('button')}
        data-testid="addVendorButton"
        onClick={() => {
          fields.push();
        }}
      >
        Add Vendor
      </button>
    </div>
  );
};

VendorFormFields.propTypes = {
  fields: PropTypes.shape({}),
};

export default VendorFormFields;
